import AstroLpAnchorController from "./astro_lp_anchor_controller"

// Same smooth-scroll-without-hash behavior as the Astro landing (see that controller
// for the iOS re-jump rationale); re-exported under a cosy-lp-* name so the Cosy
// Fantasy markup doesn't reference another product's controller.
export default class extends AstroLpAnchorController {
}
